module.exports = __webpack_public_path__ + "img/IuK_Zug.b80e5c5a.svg";